import template from './sessionExpirationModal.html';
import controller from './sessionExpirationModal.controller';

let SessionExpirationModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  backdrop: 'static',
  keyboard  : false,
  windowClass: "hmodal-warning animated zoomIn"
};

export default SessionExpirationModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/sessionExpirationModal/sessionExpirationModal.component.js